import { use } from 'react';

import { FormContainerContext } from '~contexts';

const useFormContainer = () => {
	const formContainerContext = use(FormContainerContext);
	if (formContainerContext === undefined) {
		throw new Error(
			`${FormContainerContext.displayName} must be inside a ${useFormContainer.name}`
		);
	}

	return formContainerContext;
};

export default useFormContainer;
